"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyResponseDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
class CompanyAddress {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "addressTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "123 Main St" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "address1", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "cityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "address2", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Downtown" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "area", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "10001" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "pinCode", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "1234567890" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "phoneNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "alternatePhoneNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "email", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyAddress.prototype, "supportNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddress.prototype, "id", void 0);
class CompanyAddressDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: CompanyAddress }),
    tslib_1.__metadata("design:type", CompanyAddress)
], CompanyAddressDto.prototype, "address", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: false }),
    tslib_1.__metadata("design:type", Boolean)
], CompanyAddressDto.prototype, "isPrimary", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyAddressDto.prototype, "id", void 0);
class StateGstDetailDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], StateGstDetailDto.prototype, "stateId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "22ABCDE1234F1Z5" }),
    tslib_1.__metadata("design:type", String)
], StateGstDetailDto.prototype, "gstNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 101 }),
    tslib_1.__metadata("design:type", Number)
], StateGstDetailDto.prototype, "gstCategoryLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], StateGstDetailDto.prototype, "id", void 0);
class GroupCompanyMapDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 114 }),
    tslib_1.__metadata("design:type", Number)
], GroupCompanyMapDto.prototype, "groupCompanyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Example Group" }),
    tslib_1.__metadata("design:type", String)
], GroupCompanyMapDto.prototype, "groupCompanyName", void 0);
class CompanyDocMapDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 25 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDocMapDto.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDocMapDto.prototype, "id", void 0);
class CommunicationDetailDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CommunicationDetailDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "email" }),
    tslib_1.__metadata("design:type", String)
], CommunicationDetailDto.prototype, "communicationType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "email@gmail.com" }),
    tslib_1.__metadata("design:type", String)
], CommunicationDetailDto.prototype, "communicationDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: true }),
    tslib_1.__metadata("design:type", Boolean)
], CommunicationDetailDto.prototype, "isPrimary", void 0);
class ContactOwnerDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], ContactOwnerDto.prototype, "userId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "testing1" }),
    tslib_1.__metadata("design:type", String)
], ContactOwnerDto.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "testing" }),
    tslib_1.__metadata("design:type", String)
], ContactOwnerDto.prototype, "lastName", void 0);
class ContactDepartmentDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 6 }),
    tslib_1.__metadata("design:type", Number)
], ContactDepartmentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Sales" }),
    tslib_1.__metadata("design:type", String)
], ContactDepartmentDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Sales Department" }),
    tslib_1.__metadata("design:type", String)
], ContactDepartmentDto.prototype, "description", void 0);
class ContactDesignationDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 3 }),
    tslib_1.__metadata("design:type", Number)
], ContactDesignationDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "ENGINEER" }),
    tslib_1.__metadata("design:type", String)
], ContactDesignationDto.prototype, "name", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Engineer" }),
    tslib_1.__metadata("design:type", String)
], ContactDesignationDto.prototype, "description", void 0);
class CompanyContactDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyContactDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "John" }),
    tslib_1.__metadata("design:type", String)
], CompanyContactDto.prototype, "firstName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Doe" }),
    tslib_1.__metadata("design:type", String)
], CompanyContactDto.prototype, "lastName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyContactDto.prototype, "middleName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "John Doe" }),
    tslib_1.__metadata("design:type", String)
], CompanyContactDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [CommunicationDetailDto] }),
    tslib_1.__metadata("design:type", Array)
], CompanyContactDto.prototype, "communicationDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: ContactOwnerDto }),
    tslib_1.__metadata("design:type", ContactOwnerDto)
], CompanyContactDto.prototype, "owner", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Finance" }),
    tslib_1.__metadata("design:type", String)
], CompanyContactDto.prototype, "department", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Accountant" }),
    tslib_1.__metadata("design:type", String)
], CompanyContactDto.prototype, "designation", void 0);
class CompanyDetailsDto {
}
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 114 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDetailsDto.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose test" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "companyHistory", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "majorProducts", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Ver IT" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "keyCustomers", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "documentsUploaded", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "businessProcesses", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "accountStrategy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "targetingReason", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Ver IT" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "competitor", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "weakness", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "actionPlan", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "potentialOpportunity", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "industryIntelligence", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "servicePlan", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "acquisitionHistory", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "bizProfile", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "servicePerformance", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyDetailsDto.prototype, "salesPitch", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1 }),
    tslib_1.__metadata("design:type", Number)
], CompanyDetailsDto.prototype, "id", void 0);
class CompanyResponseDto {
}
exports.CompanyResponseDto = CompanyResponseDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Example Company" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "companyName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Example" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 500 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "noOfEmployees", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "https://example.com" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "website", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "2025-03-20" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "dateOfIncorporation", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "ABCDE1234F" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "panCardNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "L98765DL1999PLC987654" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "registrationNo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 1000000 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "annualPremium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "ABCD12345E" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "tanNumber", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 114 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "For Testing Purpose" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "Internal" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "source", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: CompanyDetailsDto }),
    tslib_1.__metadata("design:type", CompanyDetailsDto)
], CompanyResponseDto.prototype, "details", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [CompanyAddressDto] }),
    tslib_1.__metadata("design:type", Array)
], CompanyResponseDto.prototype, "companyAddresses", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [StateGstDetailDto] }),
    tslib_1.__metadata("design:type", Array)
], CompanyResponseDto.prototype, "stateGstDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: GroupCompanyMapDto }),
    tslib_1.__metadata("design:type", GroupCompanyMapDto)
], CompanyResponseDto.prototype, "groupCompanyMap", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [CompanyDocMapDto] }),
    tslib_1.__metadata("design:type", Array)
], CompanyResponseDto.prototype, "companyDocMaps", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ type: [CompanyContactDto] }),
    tslib_1.__metadata("design:type", Array)
], CompanyResponseDto.prototype, "contacts", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "salesOpportunityCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "renewalOpportunityCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "policyCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "previousInsurer", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "previousTpa", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: "" }),
    tslib_1.__metadata("design:type", String)
], CompanyResponseDto.prototype, "previousBroker", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "salesOpportunityBeyondTheQuarterCount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ example: 0 }),
    tslib_1.__metadata("design:type", Number)
], CompanyResponseDto.prototype, "renewalOpportunityBeyondTheQuarterCount", void 0);
